/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getschristmascard1Inputs */

const de__field_getschristmascard1 = /** @type {(inputs: _Field_Getschristmascard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soll Weihnachtskarte erhalten`)
};

/**

* @param {_Field_Getschristmascard1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getschristmascard1 = /** @type {((inputs?: _Field_Getschristmascard1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getschristmascard1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getschristmascard1(inputs)
});
export { _field_getschristmascard1 as "_field_getsChristmascard" }